import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { moduleName } from './constants'
import { IChatSocketState, TWebSocketMessagePayload } from './types'
import { BASE_SOCKET_TYPE } from 'constants/socket'

const initialState: IChatSocketState = {
  total_unread_messages: 0,
  unread_messages: []
}

const slice = createSlice({
  name: moduleName,
  initialState,
  reducers: {
    addUnreadSocketMessage(
      state: IChatSocketState,
      action: PayloadAction<TWebSocketMessagePayload>
    ) {
      state.unread_messages.push(action.payload)
    },
    // this is needed to refresh list of chats with the chat that is currently NOT presented in the list
    // adding additional message type for that purpose and calling it on message send
    addCustomLocalMessage(
      state: IChatSocketState,
      action: PayloadAction<{ chatId: string }>
    ) {
      state.unread_messages.push({
        type: BASE_SOCKET_TYPE.LOCAL_NON_SOCKET_SEND,
        payload: {
          chat_id: action.payload.chatId
        }
      })
    },
    incrementTotalUnreadMessages(state: IChatSocketState) {
      state.total_unread_messages++
    },
    removeUnreadSocketMessagesByChatId(
      state: IChatSocketState,
      action: PayloadAction<string | string[]>
    ) {
      const chatIds = Array.isArray(action.payload)
        ? action.payload
        : [action.payload]
      state.unread_messages = state.unread_messages.filter(
        (message) => !chatIds.includes(message.payload.chat_id)
      )
    },
    clearUnreadSocketMessages(state: IChatSocketState) {
      state.unread_messages = []
    },
    setTotalUnreadMessages(
      state: IChatSocketState,
      action: PayloadAction<number>
    ) {
      state.total_unread_messages = action.payload
    },
    reset(state: IChatSocketState) {
      state.total_unread_messages = 0
      state.unread_messages = []
    }
  }
})

export default slice.reducer
export const {
  addUnreadSocketMessage,
  addCustomLocalMessage,
  incrementTotalUnreadMessages,
  removeUnreadSocketMessagesByChatId,
  clearUnreadSocketMessages,
  setTotalUnreadMessages,
  reset
} = slice.actions
